// extracted by mini-css-extract-plugin
export default {"container":"AppExplainBlock_container__D5Ivq","containerRating":"AppExplainBlock_containerRating__KcqAP"};